import { Component, h } from 'preact';
import { I } from 'intl';

class TcrProgressBox extends Component
{
    constructor(params)
    {
        super(params);

        this.state = { };
    }

    componentDidMount()
    {
        window.ProgressBox = {
            show: (msg = 'Moment bitte...') => {this.setState({success: false, show: true, msg: msg})},
            hide: (msg = 'Gespeichert.', delay = 700) => {
                if (msg === false)
                {
                    //hide immediately
                    this.setState({success: true, show: false});
                }
                else
                {   
                    //hide after 500ms
                    this.setState({success: true, msg: msg}, () => {
                        setTimeout(() => {
                            this.setState({success: true, show: false});
                        }, delay);
                    })
                }
            },
            msg: (msg) => {this.setState({msg: msg})}
        };
    }

    render()
    {
        return (
            <div class="progressbox" data-hide={!this.state.show}>
                <div class="panel">
                    <div>{this.state.msg}</div>
                </div>
            </div>
        );
    }
}

export { TcrProgressBox };